export default __webpack_public_path__ + "static/media/C.7dcac18e.svg";